import { useContext, createContext } from 'react';

export const Language = createContext();

export function useLang() {
	return useContext(Language);
}
